// extracted by mini-css-extract-plugin
export default {"cls1":"QWZ42ZxfWfxQAyQft4yM","cls2":"y2eT9VnbICrSto0tOwKw QWZ42ZxfWfxQAyQft4yM","isTabletDown":"g9pNrpV64aLVTwnwvbGu"};